<template>
  <v-container
    fluid
    class="r5"
    :class="{ 'pa-2': $vuetify.breakpoint.smAndDown }"
  >
    <v-tabs
      lazy
      right
      grow
      class="r5"
      v-model="tab"
      color="grey6"
      :ripple="false"
      slider-color="primary"
      active-class="v-tabs__item--active primary cr-team-shadow white--text text-xs-right"
    >
      <v-tab key="credits" v-if="userCan('all_credits')">
        <span class="hidden-sm-and-down">{{ $t("cash_receipts") }}</span>
        <span class="hidden-md-and-up">CRS</span>
      </v-tab>
      <v-tab key="debits" v-if="userCan('all_debits')">
        <span class="hidden-sm-and-down">{{ $t("cash_payments") }}</span>
        <span class="hidden-md-and-up">DBS</span>
      </v-tab>
      <v-tab key="exchanges" v-if="userCan('all_exchanges')">
        <span class="hidden-sm-and-down">{{ $t("exchange") }}</span>
        <span class="hidden-md-and-up">EXS</span>
      </v-tab>
      <v-tab key="a2a_transfers" v-if="userCan('all_a2a_transfers')">
        <span class="hidden-sm-and-down">{{ $t("a2a_transfers") }}</span>
        <span class="hidden-md-and-up"> A2A </span>
      </v-tab>
      <v-tab key="send_transfers" v-if="userCan('all_send_transfers')">
        <span class="hidden-sm-and-down">{{ $t("send_transfer") }}</span>
        <span class="hidden-md-and-up">STS</span>
      </v-tab>
      <v-tab key="receive_transfers" v-if="userCan('all_receive_transfers')">
        <span class="hidden-sm-and-down">{{ $t("receive_transfer") }}</span>
        <span class="hidden-md-and-up">RTS</span>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" touchless>
      <v-tab-item key="credits" lazy v-if="userCan('all_credits')">
        <credits :date="date" />
      </v-tab-item>
      <v-tab-item key="debits" lazy v-if="userCan('all_debits')">
        <debits :date="date" />
      </v-tab-item>
      <v-tab-item key="exchanges" lazy v-if="userCan('all_exchanges')">
        <exchanges :date="date" />
      </v-tab-item>
      <v-tab-item key="a2a_transfers" lazy v-if="userCan('all_a2a_transfers')">
        <a2a-transfers :date="date" label="a2a_transfers" />
      </v-tab-item>
      <v-tab-item
        key="send_transfers"
        lazy
        v-if="userCan('all_send_transfers')"
      >
        <send-transfers :date="date" label="send_transfers" />
      </v-tab-item>
      <v-tab-item
        lazy
        class="pt-2"
        key="receive_transfers"
        v-if="userCan('all_receive_transfers')"
      >
        <receive-transfers :date="date" label="received_transfers" />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import debits from "./tabs/debits";
import credits from "./tabs/credits";
import a2aTransfers from "./tabs/a2aTransfers";
import sendTransfers from "./tabs/sendTransfers";
import { customersMixin } from "@/mixins/index.js";
import receiveTransfers from "./tabs/receiveTransfers";
import exchanges from "./tabs/exchanges";

export default {
  mixins: [customersMixin],
  components: {
    debits,
    credits,
    exchanges,
    a2aTransfers,
    sendTransfers,
    receiveTransfers,
  },
  data: () => ({
    tab: null,
    date: new Date().toLocaleDateString("en-ca"),
  }),

  created() {
    this.getCustomers();
  },
};
</script>
<style>
.cr-team-shadow {
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14),
    0 7px 10px -5px rgba(233, 30, 99, 0.4);
}

.v-tabs__container--overflow {
  transform: translateX(0px) !important;
}
</style>
